<div class="generate-content-indicator-wrap" *ngIf="inProgress">
  <div
    class="generate-content-indicator"
    cdkDrag
    [cdkDragFreeDragPosition]="dragPosition"
  >
    <div
      class="indicator-collapsed"
      *ngIf="!expanded"
      (click)="toggleExpanded()"
      role="button"
      cdkDragHandle
    >
      <div class="indicator-pill">
        <div class="indicator-dot">
          <i class="fi fi-rr-magic-wand"></i>
        </div>
        <div class="indicator-text">{{ getIndicatorText() }}</div>
        <div class="indicator-chevron">
          <i class="fi fi-rr-angle-up"></i>
        </div>
      </div>
    </div>

    <div class="indicator-expanded" *ngIf="expanded">
      <div class="panel-header" cdkDragHandle>
        <div class="panel-title">
          <i class="fi fi-rr-magic-wand"></i>
          <span>{{ 'Generating Content' | translate }}</span>
        </div>
        <button class="panel-close" (click)="collapse()" type="button">
          <i class="fi fi-rr-cross"></i>
        </button>
      </div>

      <div class="panel-progress">
        <div class="panel-progress-text">{{ getIndicatorText() }}</div>
        <div class="panel-progress-bar">
          <div
            class="panel-progress-bar-fill"
            [style.width.%]="total > 0 ? (done / total) * 100 : 0"
          ></div>
        </div>
      </div>

      <div class="panel-list">
        <div class="panel-row" *ngFor="let item of list">
          <div class="row-left">
            <i [class]="getStatusIconClass(item?.status)"></i>
            <div class="row-topic">{{ getTopicLabel(item?.content_topic) }}</div>
          </div>
          <div class="row-right">
            <span class="status-badge" [ngClass]="getStatusBadgeClass(item?.status)">
              {{ getStatusLabel(item?.status) }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
